// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.KeypressDialogue_dialogueBox__tKVgn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--background-secondary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.KeypressDialogue_topHeading__48msg {
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.KeypressDialogue_topHeading__48msg span {
  display: flex;
  gap: 10px;
}

.KeypressDialogue_keypad__0emGD {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 50px;
  row-gap: 10px;
  margin-bottom: 30px;
}

.KeypressDialogue_key__CmwdM {
  width: 64px;
  height: 64px;
  border-radius: 48px;
  background: var(--background-tertiary, #f7f9fc);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.KeypressDialogue_key__CmwdM:hover {
  border: 1.5px solid var(--border-active, #1480e1);
  background: var(--background-tinted, #ecf5fe);
}
.KeypressDialogue_key__CmwdM:hover .KeypressDialogue_number__vD9Gh,
.KeypressDialogue_key__CmwdM:hover .KeypressDialogue_letter__BGVPW {
  color: var(--text-link, #1480e1);
}
.KeypressDialogue_key__CmwdM .KeypressDialogue_number__vD9Gh {
  color: var(--text-primary, #1f2023);
  text-align: center;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 85.714% */
  letter-spacing: -0.5px;
}
.KeypressDialogue_key__CmwdM .KeypressDialogue_letter__BGVPW {
  color: var(--text-secondary, #5c6168);
  text-align: center;
  font-family: Poppins;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.5px;
}

.KeypressDialogue_selected__7UKAy {
  border: 1.5px solid var(--border-active, #1480e1) !important;
  background: var(--background-tinted, #ecf5fe) !important;
}
.KeypressDialogue_selected__7UKAy .KeypressDialogue_number__vD9Gh,
.KeypressDialogue_selected__7UKAy .KeypressDialogue_letter__BGVPW {
  color: var(--text-link, #1480e1) !important;
}

.KeypressDialogue_btnBox__aoKSu {
  display: flex;
  justify-content: end;
}
.KeypressDialogue_btnBox__aoKSu button {
  display: flex;
  padding: 7px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: var(--primary-default, #0c6dc7);
  color: var(--text-on-color, #fff);
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.5px;
}

.KeypressDialogue_closeBox__6FWZD {
  cursor: pointer;
}

.KeypressDialogue_disabled__Hn1F9 {
  cursor: default;
  background: var(--primary-disabled, #c8d3e0) !important;
}

@media only screen and (max-width: 500px) {
  .KeypressDialogue_dialogueBox__tKVgn {
    top: unset;
    bottom: 0;
    left: 0;
    transform: unset;
    width: 100%;
  }
  .KeypressDialogue_btnBox__aoKSu button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionsDialogue/KeypressDialogue/KeypressDialogue.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAIA,cAAA;EACA,kBAAA;EACA,6CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAHD;;AAQA;EACC,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,aAAA;EACA,8BAAA;EAEA,mBAAA;AARD;AAUC;EACC,aAAA;EACA,SAAA;AARF;;AAYA;EACC,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AATD;;AAYA;EACC,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,+CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAVD;AAYC;EACC,iDAAA;EACA,6CAAA;AAVF;AAYE;;EAEC,gCAAA;AAVH;AAcC;EACC,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,YAAA;EACA,sBAAA;AAZF;AAeC;EACC,qCAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAbF;;AAgBA;EACC,4DAAA;EACA,wDAAA;AAbD;AAcC;;EAEC,2CAAA;AAZF;;AAeA;EACC,aAAA;EACA,oBAAA;AAZD;AAcC;EACC,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,2CAAA;EAEA,iCAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAdF;;AAiBA;EACC,eAAA;AAdD;;AAgBA;EACC,eAAA;EACA,uDAAA;AAbD;;AAgBA;EACC;IACC,UAAA;IACA,SAAA;IACA,OAAA;IACA,gBAAA;IACA,WAAA;EAbA;EAiBA;IACC,WAAA;EAfD;AACF","sourcesContent":[".dialogueBox {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\t// width: 400px;\n\t// height: 100%;\n\tflex-shrink: 0;\n\tborder-radius: 8px;\n\tbackground: var(--background-secondary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n\n\t// position: relative;\n}\n\n.topHeading {\n\tcolor: var(--text-primary, #1f2023);\n\n\t/* Subheadline/Bold */\n\tfont-family: Poppins;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 20px; /* 125% */\n\tletter-spacing: -0.5px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tmargin-bottom: 30px;\n\n\tspan {\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t}\n}\n\n.keypad {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tcolumn-gap: 50px;\n\trow-gap: 10px;\n\tmargin-bottom: 30px;\n}\n\n.key {\n\twidth: 64px;\n\theight: 64px;\n\n\tborder-radius: 48px;\n\tbackground: var(--background-tertiary, #f7f9fc);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tcursor: pointer;\n\n\t&:hover {\n\t\tborder: 1.5px solid var(--border-active, #1480e1);\n\t\tbackground: var(--background-tinted, #ecf5fe);\n\n\t\t.number,\n\t\t.letter {\n\t\t\tcolor: var(--text-link, #1480e1);\n\t\t}\n\t}\n\n\t.number {\n\t\tcolor: var(--text-primary, #1f2023);\n\t\ttext-align: center;\n\t\tfont-family: Poppins;\n\t\tfont-size: 28px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 24px; /* 85.714% */\n\t\tletter-spacing: -0.5px;\n\t}\n\n\t.letter {\n\t\tcolor: var(--text-secondary, #5c6168);\n\t\ttext-align: center;\n\t\tfont-family: Poppins;\n\t\tfont-size: 10px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t\tletter-spacing: -0.5px;\n\t}\n}\n.selected {\n\tborder: 1.5px solid var(--border-active, #1480e1) !important;\n\tbackground: var(--background-tinted, #ecf5fe) !important;\n\t.number,\n\t.letter {\n\t\tcolor: var(--text-link, #1480e1) !important;\n\t}\n}\n.btnBox {\n\tdisplay: flex;\n\tjustify-content: end;\n\n\tbutton {\n\t\tdisplay: flex;\n\t\tpadding: 7px 8px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 4px;\n\n\t\tborder-radius: 8px;\n\t\tbackground: var(--primary-default, #0c6dc7);\n\n\t\tcolor: var(--text-on-color, #fff);\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.5px;\n\t}\n}\n.closeBox {\n\tcursor: pointer;\n}\n.disabled{\n\tcursor: default;\n\tbackground: var(--primary-disabled, #c8d3e0) !important;\n}\n\n@media only screen and (max-width: 500px) {\n\t.dialogueBox {\n\t\ttop: unset;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\ttransform: unset;\n\t\twidth: 100%;\n\t}\n\n\t.btnBox {\n\t\tbutton {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogueBox": `KeypressDialogue_dialogueBox__tKVgn`,
	"topHeading": `KeypressDialogue_topHeading__48msg`,
	"keypad": `KeypressDialogue_keypad__0emGD`,
	"key": `KeypressDialogue_key__CmwdM`,
	"number": `KeypressDialogue_number__vD9Gh`,
	"letter": `KeypressDialogue_letter__BGVPW`,
	"selected": `KeypressDialogue_selected__7UKAy`,
	"btnBox": `KeypressDialogue_btnBox__aoKSu`,
	"closeBox": `KeypressDialogue_closeBox__6FWZD`,
	"disabled": `KeypressDialogue_disabled__Hn1F9`
};
export default ___CSS_LOADER_EXPORT___;
